import gsap from 'gsap';

export const hide = e => {
    gsap.set(e, {
        autoAlpha: 0,
        pointerEvents: 'none'
    })
}
